// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EP8j","col":"styles_col__tA6p3"};